/**
 * Tourist Taxes Guide Component
 * Based on: documentation/cursor/owner-dashboard-ui-specification-v1-final.md
 * Section 4, Component 18: Tourist Taxes Guide
 */

import { useState } from 'react';

export default function TouristTaxesGuide({ taxConfig }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={styles.card}>
      <div style={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <h3 style={styles.title}>Tourist Taxes Guide</h3>
        <span style={{
          ...styles.chevron,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div style={styles.content}>
          <section style={styles.section}>
            <h4 style={styles.sectionTitle}>Tax Configuration</h4>
            <p style={styles.text}>
              Tourist taxes are calculated based on the number of nights and guest count.
              {taxConfig?.state_rate && (
                <> State rate: {taxConfig.state_rate}%</>
              )}
              {taxConfig?.county_rate && (
                <> County rate: {taxConfig.county_rate}%</>
              )}
            </p>
          </section>
          <section style={styles.section}>
            <h4 style={styles.sectionTitle}>Remittance Method</h4>
            <p style={styles.text}>
              {taxConfig?.remittance_method || 'Taxes are remitted automatically through the platform.'}
            </p>
          </section>
          {taxConfig?.notes && (
            <section style={styles.section}>
              <h4 style={styles.sectionTitle}>Notes</h4>
              <p style={styles.text}>{taxConfig.notes}</p>
            </section>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'var(--color-bg-primary)',
    border: '1px solid var(--color-border-light)',
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--spacing-5)',
    boxShadow: 'var(--shadow-md)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  title: {
    fontSize: 'var(--font-size-lg)',
    fontWeight: 'var(--font-weight-semibold)',
    color: 'var(--color-text-primary)',
    margin: 0,
  },
  chevron: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    transition: 'var(--transition-base)',
  },
  content: {
    marginTop: 'var(--spacing-5)',
    paddingTop: 'var(--spacing-5)',
    borderTop: '1px solid var(--color-border-light)',
  },
  section: {
    marginBottom: 'var(--spacing-5)',
  },
  sectionTitle: {
    fontSize: 'var(--font-size-base)',
    fontWeight: 'var(--font-weight-semibold)',
    color: 'var(--color-text-primary)',
    margin: 0,
    marginBottom: 'var(--spacing-2)',
  },
  text: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-text-secondary)',
    lineHeight: 'var(--line-height-relaxed)',
    margin: 0,
  },
};

